import {
  generateViewContentParams,
  itemsToFacebookConversionProducts,
} from '../ECommerceAnalytics/FacebookConversions'
import { getCurrentUtmParams, getInitialUtmParams } from './utm'
import UserManager from '../UserManager'
import { analytics } from './Analytics'

export function getEnrichedFacebookEventData({
  orderTrackingData,
  initialUserParams,
  orderItems,
  value,
  currency = orderTrackingData.Currency,
  contentParams = {},
}) {
  const products =
    orderItems?.length > 0
      ? itemsToFacebookConversionProducts({
          items: orderItems,
          value,
          currency,
          contentParams,
        })
      : {}
  return {
    ...getCurrentUtmParams(),
    ...getInitialUtmParams(initialUserParams),
    ...products,
    coupon: orderTrackingData['Promo Code'] || null,
    num_items: orderTrackingData['Order Tiles'],
    tile_size: orderTrackingData['Tile Sizes'],
    referrer: document.referrer,
    shipping_cost: orderTrackingData['USD Shipping Cost'],
    order_revenue_usd: orderTrackingData['USD Revenue'],
    who_is_it_for: orderTrackingData['Who Is It For'],
  }
}

export function trackViewContent({
  id,
  totalPrice,
  productType,
  contentCategory,
  contentName,
}) {
  UserManager.getInitialUserParams().then((initialUserParams) => {
    analytics.facebookTrack('ViewContent', {
      ...getCurrentUtmParams(),
      ...getInitialUtmParams(initialUserParams),
      ...generateViewContentParams({
        ids: [id],
        totalPrice,
        contentCategory,
        contentName,
      }),
      referrer: document.referrer,
      product_type: productType,
    })
  })
}
